import $ from "jquery";
import { CHOOSE_MATERIAL } from "./_selectors";
import { materialDescriptions } from "./materialUtils";

function addDescriptiontext() {
	console.log("Adding description text, materialDescriptions:", materialDescriptions);

	const htmlString = `
    <ul class="description-text">
        ${Object.entries(materialDescriptions)
					.map(([key, value]) => {
						console.log(`Creating description for: "${key}"`);
						return `<li data-id="${key}">${value}</li>`;
					})
					.join("")}
    </ul>
    `;

	// Append the description text directly to the material wrapper
	// It will show after all the material buttons
	$(CHOOSE_MATERIAL).append(htmlString);

	// Show the first description by default
	const firstLi = $(CHOOSE_MATERIAL).find(".description-text li:first-of-type");
	if (firstLi.length > 0) {
		firstLi.addClass("show");
		console.log("Set first description as visible:", firstLi.attr("data-id"));
	}
}

export default addDescriptiontext;
